import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getMessaging, isSupported } from 'firebase/messaging';
import { getFunctions } from 'firebase/functions';

// NOTE: appId below is a placeholder ("web:abcdef123456").
// Copy the real Web App ID from Firebase Console → Project Settings → Your apps
// (same project as the iOS app's GoogleService-Info.plist: ez-maps-19ee0).
const firebaseConfig = {
  apiKey: "AIzaSyDOjt1bdKGMw50-wKYzBKwMeE33FJt6LLw",
  authDomain: "ez-maps-19ee0.firebaseapp.com",
  projectId: "ez-maps-19ee0",
  storageBucket: "ez-maps-19ee0.firebasestorage.app",
  messagingSenderId: "104584445203",
  appId: "1:104584445203:web:abcdef123456"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

// Messaging is only supported in browsers that support service workers
export const getMessagingIfSupported = async () => {
  try {
    return (await isSupported()) ? getMessaging(app) : null;
  } catch {
    return null;
  }
};

export default app;
